export function formatDelay(seconds?: number | null) {
  if (seconds == null) return "—"
  if (Math.abs(seconds) < 45) return "on time"
  const mins = Math.round(Math.abs(seconds) / 60)
  return seconds > 0 ? `${mins}m late` : `${mins}m early`
}

export function delayTone(seconds?: number | null) {
  if (seconds == null) return ""
  if (Math.abs(seconds) < 45) return "ok"
  return seconds > 0 ? "late" : "early"
}

export function formatClock(value?: number | null) {
  if (value == null || Number.isNaN(value)) return "—"

  if (value > 1e12) {
    return new Date(value).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })
  }

  if (value > 1e9) {
    return new Date(value * 1000).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })
  }

  const seconds = value > 1e5 ? Math.floor(value / 1000) : Math.floor(value)
  const hours = Math.floor(seconds / 3600) % 24
  const minutes = Math.floor((seconds % 3600) / 60)
  const date = new Date()
  date.setHours(hours, minutes, 0, 0)
  return date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" })
}

export function formatProgress(progress?: number | null) {
  if (progress == null) return "—"
  return `${Math.round(progress * 100)}%`
}

export function formatAvgDelay(seconds?: number | null) {
  if (seconds == null) return "—"
  const mins = Math.round(Math.abs(seconds) / 60)
  if (mins === 0) return "on time"
  return seconds > 0 ? `+${mins}m` : `−${mins}m`
}
